import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Box, Paper, Typography, Container, useTheme } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const AuthLayout: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const theme = useTheme();
  
  // If authenticated, redirect to dashboard
  if (isAuthenticated && !loading) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        backgroundImage: 'linear-gradient(120deg, rgba(25, 118, 210, 0.1), rgba(3, 169, 244, 0.1))',
      }}
    >
      <Container maxWidth="lg" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Paper
          elevation={3}
          sx={{
            display: 'flex',
            width: '100%',
            maxWidth: 1000,
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
          }}
        >
          {/* Left side - Branding and info */}
          <Box
            sx={{
              flex: 1,
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              p: 6,
              color: 'white',
              backgroundColor: 'primary.main',
              backgroundImage: 'linear-gradient(135deg, #1976d2, #03a9f4)',
              textAlign: 'center',
            }}
          >
            <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
              Visitor Management System
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, maxWidth: 400 }}>
              A modern solution for managing visitors, enhancing security, and streamlining the check-in process.
            </Typography>
            <Box
              component="img"
              src="/logo.png"
              alt="VMS Logo"
              sx={{
                width: 200,
                height: 200,
                opacity: 0.9,
                mb: 4,
                display: 'none', // Hide until logo is available
              }}
            />
            <Box sx={{ mt: 4 }}>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                • Streamlined visitor check-in and check-out
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                • Pre-registration for expected visitors
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                • Host notifications
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                • Visitor badge printing
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                • Comprehensive reporting
              </Typography>
            </Box>
          </Box>
          
          {/* Right side - Auth forms */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              p: { xs: 3, sm: 6 },
            }}
          >
            <Outlet />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AuthLayout;
